// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gust-front-and-storm-turbulence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gust-front-and-storm-turbulence/gust-front-and-storm-turbulence.js';

mount([g0]);
